import { render, staticRenderFns } from "./CytologyResultsBuilder.vue?vue&type=template&id=bec484da&scoped=true&"
import script from "./CytologyResultsBuilder.vue?vue&type=script&lang=js&"
export * from "./CytologyResultsBuilder.vue?vue&type=script&lang=js&"
import style0 from "./CytologyResultsBuilder.vue?vue&type=style&index=0&id=bec484da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec484da",
  null
  
)

export default component.exports